import { designTokens } from '@/shared/lib/design-tokens'
import { typographyStyle } from '@/shared/lib/catalog'
import { NavLink } from 'react-router-dom'

type CatalogHeaderProps = {
  copyMessage?: string | null
}

export function CatalogHeader({ copyMessage }: CatalogHeaderProps) {
  const tabs: Array<{ label: string; to: string; end?: boolean }> = [
    { label: 'Gallery', to: '/ui-catalog', end: true },
    { label: 'Tokens', to: '/ui-catalog/tokens' },
    { label: 'Layouts', to: '/ui-catalog/layouts' },
  ]

  return (
    <div className="space-y-4 px-6">
      <h1 className="text-foreground" style={typographyStyle(designTokens.typography.heading.h1)}>
        UI Components Catalog
      </h1>
      <p
        className="max-w-3xl text-muted-foreground"
        style={typographyStyle(designTokens.typography.body.base)}
      >
        Browse approved primitives, tokens, and usage snippets. Each entry is derived from the
        component inventory and mapped to the current design tokens.
      </p>
      <p
        className="text-sm text-muted-foreground"
        style={typographyStyle(designTokens.typography.body.sm)}
      >
        Source of truth: <span className="font-medium">design-tokens.json</span> and{' '}
        <span className="font-medium">design-system-analysis.md</span>.
      </p>
      <p className="sr-only" aria-live="polite">
        {copyMessage}
      </p>
      <div className="flex flex-wrap gap-2 pt-2" role="tablist" aria-label="Catalog sections">
        {tabs.map((tab) => (
          <NavLink
            key={tab.label}
            to={tab.to}
            end={tab.end}
            role="tab"
            className={({ isActive }) =>
              `rounded-full border px-4 py-1.5 text-sm font-medium transition ${
                isActive
                  ? 'border-primary bg-primary text-primary-foreground'
                  : 'border-border bg-background text-muted-foreground hover:border-primary/60 hover:text-foreground'
              }`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
    </div>
  )
}
